import type { Cascadify } from './util'
import type { Media } from './media'

export enum RoomMediaType {
  Image = 'image',
  Logo = 'logo',
  LoginLogo = 'login-logo',
  Background = 'background',
  LatecomerVideo = 'latecomer-video',
  InterimVideo = 'interim-video',
  EndEarlyVideo = 'end-early-video',
  Audio = 'audio',
}

export type RoomMediaSettings = {
  volume?: number
  keypress?: string
  overlay?: boolean
}

export type RoomMedia = {
  id: number
  roomId: number
  mediaId: number
  type: RoomMediaType
  media: Media
  settings: RoomMediaSettings
}

export type CascadeRoomMedia = Cascadify<RoomMedia>
